import axios from "axios";
// Config global defaults for axios/django
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.xsrfCookieName = "csrftoken";
/**
 * Available endpoints
 *
 * */
// ex: "/api/whiteboard?room=12387501270341"
export const API_GET_WHITEBOARD_HISTORY = "/api/whiteboard/";
export const API_POST_CREATE_WHITEBOARD = "/api/whiteboard/new/";
export const API_POST_WHITEBOARD_MESSAGE = "/api/whiteboard/messages/";
export const API_POST_WHITEBOARD_MESSAGE_REACTION = "/api/whiteboard/messages/reaction/";
export const API_POST_WHITEBOARD_VOICE_TRANSCRIBE = "/api/v1/audio/transcribe";
export const API_GET_ACTIVE_ROOMS = "/api/active-rooms/";
export const API_GET_LOBBY_INFO = "/api/lobby/";
export const API_GET_EVENTS_HISTORY = "/api/events/";
export const API_GET_DM_PREVIEW = "/api/dm-preview/";
export const API_GET_DM_HISTORY = "/api/dm-history/";
export const API_URL_SETTINGS = "/api/url-settings/";
export const API_URL_SETTING = "/api/url-setting/";
export const API_URL_ANNOUNCEMENT = "/api/url-announcement/";
export const API_ANNOUNCEMENTS = "/api/url-announcements/";
export const API_GET_DOMAIN_BLOCKLIST = "/api/domain-blocklist/";
export const API_GET_DOMAIN_KEYPHRASE_BLOCKLIST = "/api/domain-keyphrase-blocklist/";
export const API_GET_DOMAIN_SETTINGS = "/api/domain/"; // api/domain/<str:domain>/settings
export const API_TEST_TOKEN = "/api/get-user-info/";
export const API_WHITEBOARD_UNREAD_MSG = "/api/whiteboard-unread-message/";
export const API_WHITEBOARD_HOT_ROOM = "/api/hot-room/";
export const API_GET_USER_PROFILE = "/api/v1/user-profile/get/";
export const API_UPDATE_USER_PROFILE = "/api/v1/user-profile/update/";
export const API_USER_CONTACTS = "/api/v1/user-contacts/";
export const API_USER_CONTACT = "/api/v1/user-contact/";
export const API_POST_USER_ENGAGEMENT_EVENT = "/api/user-engagement-event/"; // deprecated in the future
export const API_POST_LOBBY_OPEN_EVENT = "/api/lobby-open-event/";
export const API_GET_REWARD = "/api/get-user-reward/"; // /api/get-user-reward/
export const API_GET_VOUCHER_LIST = "/api/get-voucher-list/"; // /api/get-voucher-list/
export const API_POST_REDEEM_VOUCHER = "/api/redeem-voucher/";
export const API_GET_B_TO_C_PREVIEW = "/api/b-to-c-preview/";
export const API_GET_B_TO_C_HISTORY = "/api/b-to-c-history/";
export const API_GET_DOMAIN_ROUTE_BLOCKLIST = "/api/domain-route-blocklist/";
export * from "./api.interfaces";
export * from "./utils/dm.utils";
export * from "./utils/b_to_c.utils";
export default axios;
//# sourceMappingURL=index.js.map